import { Request, Response } from "express";
import { BobrequestPipelineFactory } from "../domain/factories/bobrequest-pipeline-factory";
import { BobRequest } from "../domain/model/bob-request";
import { IPipeline } from "../domain/pipelines/pipeline.inferface";
import { BOBEnvironment } from "./bob-environment";

export class RequestHandler {

	private bobrequestPipelineFactory: BobrequestPipelineFactory;
	private pipeline: IPipeline<Request, Promise<BobRequest>>;
	private request: BobRequest;

	constructor(bobrequestPipelineFactory) {

		this.bobrequestPipelineFactory = bobrequestPipelineFactory;
	}

	public getHandler(): (req: Request, res: Response) => Promise<void> {

		return async (req: Request, res: Response) => {
			// console.log(req);

			try {
				this.pipeline = this.createPipeline(req);
				this.request = await this.pipeline.run(req);

				// console.log(this.request);;

				// Make sure that cloudflare doesnt cache a response with failed microservices.
				// This would lead to semi broken pages until the cache is cleared
				if (!this.microservicesAreRendered(this.request)) {

					this.request.headers["cache-control"] = "no-cache";
				}

				res.set(this.request.headers).status(this.request.status).send(this.request.html);
			} catch (error) {
				throw error;
			}
		};
	}

	public createPipeline(req: Request): IPipeline<Request, Promise<BobRequest>> {

		return this.bobrequestPipelineFactory.create(req,
			BOBEnvironment.getCorrectHostnameByRequest(req),
			process.env.BOB_ORIGIN_PROTOCOL as string,
			process.env.BOB_ORIGIN_PORT as string
		);
	}

	public microservicesAreRendered(req: BobRequest): boolean {

		return req.microservices.every(microservice => {

			return microservice.isLoaded === true;
		});
	}
}
